import React from 'react'
import styled from 'styled-components'
import moment from '../../../../lib/moment.js'
import orderBy from 'lodash/orderBy'
import get from 'lodash/get'
import find from 'lodash/find'
import PropTypes from 'prop-types'
import shortid from 'shortid'

export const HourRowMobile = (props) => {
  const selectedDate = moment(get(props, 'selectedDate'))
  const { sumHoursByDate, maximumWorkingHoursPerDay, weekdates } = props
  let sumHours = []
  const isSubcontract = get(props, 'authData.user.employee_type') === 'Subcontract'
  Object.keys(sumHoursByDate).forEach(s => {
    sumHours.push({ date: s, hours: sumHoursByDate[s] })
  })
  sumHours = orderBy(sumHours, ['date'], 'asc')

  return (
    <Wrapper>
      <Column>
        <Total />
        { weekdates.map(sum => {
          const isToday = moment(sum).isSame(moment(), 'day')
          const date = find(sumHours, {
            date: moment(sum).format('YYYY-MM-DD'),
          })
          const maximum = date ? maximumWorkingHoursPerDay[date.date].hours : 0
          const hours = date ? get(date, 'hours') : 0
          return (
            <Cell key={ shortid() }>
              <Date
                isToday={ isToday }
                valid={
                  isSubcontract ?
                    hours <= maximum
                    : hours === maximum
                }
              >{ selectedDate.month() === moment(sum).month() ? hours : '' }</Date>
            </Cell>
          )
        }) }
        <div style={ { width: '10%' } } />
      </Column>
    </Wrapper>
  )
}

HourRowMobile.propTypes = {
  sumHoursByDate: PropTypes.object,
  maximumWorkingHoursPerDay: PropTypes.object,
  weekdates: PropTypes.array,
}
HourRowMobile.defaultProps = {
  sumHoursByDate: {},
  maximumWorkingHoursPerDay: {},
  weekdates: [],
}

const Wrapper = styled.div`
  background-color: #EEEEEE ;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  height: 70px;
  flex-direction: row;
  flex: 1;
  align-items: center;
  @media (max-width: 1199.98px) {
    display: none;
  }
  @media (max-width: 991.98px) {
    display: none;
  }
  @media (max-width: 575.98px) {
    display: flex;
    padding-top: 40px;
  }
  @media (max-width: 767.98px) {
    display: flex;
    padding-top: 40px;
  }
  @media (min-width: 1200px) {
    display: none;
  }

`
const Column = styled.div`
  height: 100%;
  background-color: #EEEEEE;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const Cell = styled.div`
  font-family: Gotham;
  font-size: 12px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: solid #EAEAEA;
  border-width: 0px 0.5px 0px 0.5px;
`
const Date = styled.div`
  font-family: Gotham-Bold;
  color: ${props => { return props.valid ? '#499B49' : '#D44B49' }};
`
const Total = styled.span`
  width: 5%;
  margin-right: 2%;
  font-family: 'Gotham-Bold' !important;
  font-size: 10px;
  text-align: center;
  margin-top: 5px;
  margin-bottom: 10px;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/hour-row-mobile.js